module.exports = __webpack_public_path__ + "static/img/application13-2.20f302d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application13-2.jpg
// module id = Mm5n
// module chunks = 0